// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProfessionalStudiesTab_studies-tab__zyZAU {
  width: 100%;
  font-family: "Sora", sans-serif;
}
.ProfessionalStudiesTab_studies-tab__empty__viNgo {
  font-size: 14px;
  color: rgba(19, 35, 29, 0.68);
  font-style: italic;
  padding: 20px 0;
}

.ProfessionalStudiesTab_msp-notice__1DM4h {
  margin-bottom: 32px;
}
.ProfessionalStudiesTab_msp-notice__card__FQRrY {
  display: flex;
  gap: 16px;
  background: rgba(214, 166, 64, 0.08);
  border: 1px solid rgba(214, 166, 64, 0.2);
  border-radius: 18px;
  padding: 16px 20px;
  align-items: flex-start;
}
.ProfessionalStudiesTab_msp-notice__icon__iYEd8 {
  color: #D6A640;
  flex-shrink: 0;
  margin-top: 2px;
}
.ProfessionalStudiesTab_msp-notice__text__Pb0Wn strong {
  display: block;
  font-size: 14px;
  font-weight: 800;
  color: #8a6516;
  margin-bottom: 4px;
}
.ProfessionalStudiesTab_msp-notice__text__Pb0Wn p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #8a6516;
}

.ProfessionalStudiesTab_studies-editor__header__EJjaq {
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 600px) {
  .ProfessionalStudiesTab_studies-editor__header__EJjaq {
    justify-content: center;
  }
  .ProfessionalStudiesTab_studies-editor__header__EJjaq button {
    width: 100%;
  }
}
.ProfessionalStudiesTab_studies-editor__grid__2YsTM {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}
.ProfessionalStudiesTab_studies-editor__error-msg__fFKAs {
  color: #C95C5C;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: center;
}

.ProfessionalStudiesTab_studies-tab__list__C-Tcb {
  margin-bottom: 20px;
}

.ProfessionalStudiesTab_studies-editor__heading__gDbsx {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
}
.ProfessionalStudiesTab_studies-editor__title__7TpB8 {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: #13231D;
  line-height: 1.08;
}
.ProfessionalStudiesTab_studies-editor__intro__3DRdP {
  margin: 9px 0 0;
  font-size: 14px;
  line-height: 1.65;
  color: rgba(21, 36, 30, 0.6);
  max-width: 620px;
}
.ProfessionalStudiesTab_studies-editor__count__TG7K6 {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid rgba(130, 177, 148, 0.26);
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.09);
  color: #5E806C;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}
.ProfessionalStudiesTab_studies-editor__order-note__BWtxe {
  margin-bottom: 18px;
  padding: 14px 16px;
  border: 1px solid rgba(130, 177, 148, 0.22);
  border-radius: 16px;
  background: rgba(130, 177, 148, 0.07);
  color: #53645c;
  font-size: 13px;
  line-height: 1.55;
}
.ProfessionalStudiesTab_studies-editor__order-note__BWtxe strong {
  color: #31473b;
}
.ProfessionalStudiesTab_studies-editor__header__EJjaq {
  margin-top: 6px;
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 600px) {
  .ProfessionalStudiesTab_studies-editor__header__EJjaq {
    margin-top: 10px;
    margin-bottom: 20px;
    justify-content: center;
  }
  .ProfessionalStudiesTab_studies-editor__header__EJjaq button {
    width: 100%;
    min-height: 44px;
    border-radius: 14px;
  }
}
.ProfessionalStudiesTab_studies-editor__grid__2YsTM {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}
.ProfessionalStudiesTab_studies-editor__error-msg__fFKAs {
  color: #C95C5C;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: center;
}

.ProfessionalStudiesTab_study-editor-card__wZf-f {
  position: relative;
  padding: 18px;
  border: 1px solid rgba(19, 35, 29, 0.09);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.45);
  transition: border-color 0.2s ease;
}
.ProfessionalStudiesTab_study-editor-card__wZf-f:hover {
  border-color: rgba(130, 177, 148, 0.32);
}
.ProfessionalStudiesTab_study-editor-card__head__prH7g {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}
.ProfessionalStudiesTab_study-editor-card__number__8lO8\\+ {
  font-size: 12px;
  font-weight: 800;
  color: #5f6e68;
  margin-right: auto;
}
.ProfessionalStudiesTab_study-editor-card__actions__R4LxK {
  display: flex;
  align-items: center;
  gap: 7px;
}
.ProfessionalStudiesTab_study-editor-card__icon-btn__WbCEl {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(19, 35, 29, 0.09);
  border-radius: 10px;
  background: #fff;
  color: #65736d;
  cursor: pointer;
  transition: all 0.2s;
}
.ProfessionalStudiesTab_study-editor-card__icon-btn__WbCEl:hover:not(:disabled) {
  border-color: rgba(130, 177, 148, 0.48);
  color: #5E806C;
}
.ProfessionalStudiesTab_study-editor-card__icon-btn__WbCEl:disabled {
  opacity: 0.32;
  cursor: not-allowed;
}
.ProfessionalStudiesTab_study-editor-card__icon-btn--delete__Ss84S {
  color: #C95C5C;
  background: #FEF2F2;
  border: 1px solid rgba(201, 92, 92, 0.4);
}
.ProfessionalStudiesTab_study-editor-card__icon-btn--delete__Ss84S:hover:not(:disabled) {
  background: #C95C5C;
  color: #fff;
  border-color: transparent;
}
.ProfessionalStudiesTab_study-editor-card__icon-btn--edit__Y3VK9 {
  color: #5E806C;
  background: rgba(130, 177, 148, 0.1);
  border-color: rgba(130, 177, 148, 0.32);
}
.ProfessionalStudiesTab_study-editor-card__icon-btn--edit__Y3VK9:hover:not(:disabled) {
  background: rgba(130, 177, 148, 0.22);
  border-color: rgba(130, 177, 148, 0.55);
  color: #315042;
}
.ProfessionalStudiesTab_study-editor-card__body__qJFEU {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.ProfessionalStudiesTab_study-editor-card__title__l\\+rYi {
  display: block;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  color: #13231D;
}
.ProfessionalStudiesTab_study-editor-card__institution__Kx1rA {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(21, 36, 30, 0.55);
}
.ProfessionalStudiesTab_study-editor-card__tags__Gd1YU {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.ProfessionalStudiesTab_study-editor-card__tag__xmqPS {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 9px;
  border-radius: 999px;
  border: 1px solid rgba(130, 177, 148, 0.24);
  background: rgba(130, 177, 148, 0.08);
  font-size: 10px;
  font-weight: 800;
  color: #496552;
}
.ProfessionalStudiesTab_study-editor-card__meta__JIGh8 {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed rgba(19, 35, 29, 0.09);
  color: #7b8882;
  font-size: 10px;
  line-height: 1.55;
}
.ProfessionalStudiesTab_study-editor-card__cert-link__5OT0h {
  background: none;
  border: none;
  color: #82B194;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
  text-decoration: underline;
}

.ProfessionalStudiesTab_edit-card__sHcsH {
  position: relative;
  background: #ffffff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 20px;
  padding: 28px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .ProfessionalStudiesTab_edit-card__sHcsH {
    padding: 22px;
  }
}
@media (max-width: 480px) {
  .ProfessionalStudiesTab_edit-card__sHcsH {
    padding: 16px;
  }
}
.ProfessionalStudiesTab_edit-card__sHcsH:hover {
  border-color: rgba(130, 177, 148, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
}
.ProfessionalStudiesTab_edit-card__actions-wrap__m1tdn {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
}
.ProfessionalStudiesTab_edit-card__delete-btn__daTqF {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid rgba(201, 92, 92, 0.4);
  background: #FEF2F2;
  color: #C95C5C;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.ProfessionalStudiesTab_edit-card__delete-btn__daTqF:hover {
  background: #C95C5C;
  color: #fff;
  border-color: transparent;
}
.ProfessionalStudiesTab_edit-card__collapse-btn__Ext93 {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid rgba(19, 35, 29, 0.1);
  background: rgba(255, 255, 255, 0.8);
  color: #6B8277;
  display: grid;
  place-items: center;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}
.ProfessionalStudiesTab_edit-card__collapse-btn__Ext93:hover {
  background: rgba(19, 35, 29, 0.06);
  color: #13231D;
}
.ProfessionalStudiesTab_edit-card__reorder-btn__Fqlnv {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid rgba(130, 177, 148, 0.42);
  background: rgba(255, 255, 255, 0.88);
  color: #426652;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.ProfessionalStudiesTab_edit-card__reorder-btn__Fqlnv:hover:not(:disabled) {
  background: rgba(130, 177, 148, 0.12);
  color: #13231d;
  border-color: #82B194;
}
.ProfessionalStudiesTab_edit-card__reorder-btn__Fqlnv:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  border-color: rgba(19, 35, 29, 0.08);
  color: #b0b7b3;
  background: transparent;
}
.ProfessionalStudiesTab_edit-card__form-grid__VzFgX {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 15px;
}
.ProfessionalStudiesTab_edit-card__row__dW2Au {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 600px) {
  .ProfessionalStudiesTab_edit-card__row__dW2Au {
    grid-template-columns: 1fr;
  }
}
.ProfessionalStudiesTab_edit-card__file-section__WLcwR {
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px dashed rgba(16, 25, 21, 0.08);
}
.ProfessionalStudiesTab_edit-card__label-small__lkpf5 {
  display: block;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6B8277;
  margin-bottom: 10px;
}
.ProfessionalStudiesTab_edit-card__file-controls__T6Z8o {
  display: flex;
  align-items: center;
  gap: 16px;
}
@media (max-width: 600px) {
  .ProfessionalStudiesTab_edit-card__file-controls__T6Z8o {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .ProfessionalStudiesTab_edit-card__file-controls__T6Z8o button {
    width: 100%;
  }
}
.ProfessionalStudiesTab_edit-card__view-link__5KJoK {
  background: none;
  border: none;
  color: #82B194;
  font-size: 13px;
  font-weight: 800;
  text-decoration: underline;
  cursor: pointer;
  font-family: inherit;
}
.ProfessionalStudiesTab_edit-card__loading__DC9gh {
  padding: 10px;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/EditProfileProfessional/components/EditTabs/TabsContents/ProfessionalStudiesTab.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAPA;EACI,WAAA;EACA,+BAAA;AAUJ;AARI;EACI,eAAA;EACA,6BDWe;ECVf,kBAAA;EACA,eAAA;AAUR;;AANA;EACI,mBAAA;AASJ;AAPI;EACI,aAAA;EACA,SAAA;EACA,oCAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AASR;AANI;EACI,cDrBe;ECsBf,cAAA;EACA,eAAA;AAQR;AAJQ;EAAS,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,kBAAA;AAWpF;AAVQ;EAAI,SAAA;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAgB1D;;AAXI;EACI,mBAAA;EACA,aAAA;EACA,yBAAA;AAcR;AAZQ;EALJ;IAMQ,uBAAA;EAeV;EAdU;IAAS,WAAA;EAiBnB;AACF;AAdI;EACI,aAAA;EACA,0BAAA;EACA,SAAA;AAgBR;AAbI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAeR;;AAXA;EACI,mBAAA;AAcJ;;AAVI;EACI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAaR;AAVI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AAYR;AATI;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AAWR;AARI;EACI,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,oBAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAUR;AAPI;EACI,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AASR;AAPQ;EAAS,cAAA;AAUjB;AAPI;EACI,eAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AASR;AAPQ;EANJ;IAOQ,gBAAA;IACA,mBAAA;IACA,uBAAA;EAUV;EARU;IACI,WAAA;IACA,gBAAA;IACA,mBAAA;EAUd;AACF;AANI;EACI,aAAA;EACA,0BAAA;EACA,SAAA;AAQR;AALI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAOR;;AAFA;EACI,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,qCAAA;EACA,kCAAA;AAKJ;AAHI;EACI,uCAAA;AAKR;AAFI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAIR;AADI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAGR;AAAI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAER;AACI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AACR;AACQ;EACI,uCAAA;EACA,cAAA;AACZ;AAEQ;EACI,aAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,cAAA;EACA,mBAAA;EACA,wCAAA;AADZ;AAGY;EACI,mBAAA;EACA,WAAA;EACA,yBAAA;AADhB;AAKQ;EACI,cAAA;EACA,oCAAA;EACA,uCAAA;AAHZ;AAKY;EACI,qCAAA;EACA,uCAAA;EACA,cAAA;AAHhB;AAQI;EACI,aAAA;EACA,sBAAA;EACA,MAAA;AANR;AASI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAPR;AAUI;EACI,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AARR;AAWI;EACI,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AATR;AAYI;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,2CAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAVR;AAaI;EACI,gBAAA;EACA,iBAAA;EACA,6CAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAXR;AAcI;EACI,gBAAA;EACA,YAAA;EACA,cDjSe;ECkSf,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,0BAAA;AAZR;;AAgBA;EACI,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAbJ;AAeI;EARJ;IASQ,aAAA;EAZN;AACF;AAcI;EAZJ;IAaQ,aAAA;EAXN;AACF;AAaI;EACI,sCAAA;EACA,0CAAA;AAXR;AAcI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;AAZR;AAeI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAbR;AAeQ;EAAU,mBAAA;EAAqB,WAAA;EAAa,yBAAA;AAVpD;AAaI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uCAAA;EACA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAXR;AAaQ;EAAU,kCAAA;EAAoC,cAAA;AATtD;AAaI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,qCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAXR;AAaQ;EACI,qCAAA;EACA,cAAA;EACA,qBAAA;AAXZ;AAcQ;EACI,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,uBAAA;AAZZ;AAgBI;EACI,aAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;AAdR;AAiBI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAfR;AAgBQ;EAJJ;IAIgC,0BAAA;EAZlC;AACF;AAcI;EACI,eAAA;EACA,iBAAA;EACA,6CAAA;AAZR;AAeI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAbR;AAgBI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAdR;AAgBQ;EALJ;IAMQ,sBAAA;IACA,oBAAA;IACA,SAAA;EAbV;EAeU;IAAS,WAAA;EAZnB;AACF;AAeI;EACI,gBAAA;EACA,YAAA;EACA,cDlbe;ECmbf,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,oBAAA;AAbR;AAgBI;EAAa,aAAA;EAAe,aAAA;EAAe,uBAAA;AAX/C","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-gold: $color-gold;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-border: $color-border;\n$bw-surface-2: $color-surface-soft;\n\n.studies-tab {\n    width: 100%;\n    font-family: \"Sora\", sans-serif;\n\n    &__empty {\n        font-size: 14px;\n        color: $bw-muted;\n        font-style: italic;\n        padding: 20px 0;\n    }\n}\n\n.msp-notice {\n    margin-bottom: 32px;\n\n    &__card {\n        display: flex;\n        gap: 16px;\n        background: rgba($bw-gold, 0.08);\n        border: 1px solid rgba($bw-gold, 0.2);\n        border-radius: 18px;\n        padding: 16px 20px;\n        align-items: flex-start;\n    }\n\n    &__icon {\n        color: $bw-gold;\n        flex-shrink: 0;\n        margin-top: 2px;\n    }\n\n    &__text {\n        strong { display: block; font-size: 14px; font-weight: 800; color: #8a6516; margin-bottom: 4px; }\n        p { margin: 0; font-size: 13px; line-height: 1.5; color: #8a6516; }\n    }\n}\n\n.studies-editor {\n    &__header {\n        margin-bottom: 24px;\n        display: flex;\n        justify-content: flex-end;\n\n        @media (max-width: 600px) {\n            justify-content: center;\n            button { width: 100%; }\n        }\n    }\n\n    &__grid {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n\n    &__error-msg {\n        color: #C95C5C;\n        font-size: 13px;\n        font-weight: 700;\n        margin-bottom: 16px;\n        text-align: center;\n    }\n}\n\n.studies-tab__list {\n    margin-bottom: 20px;\n}\n\n.studies-editor {\n    &__heading {\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        gap: 18px;\n        margin-bottom: 18px;\n    }\n\n    &__title {\n        margin: 0;\n        font-size: 30px;\n        font-weight: 700;\n        letter-spacing: -0.04em;\n        color: #13231D;\n        line-height: 1.08;\n    }\n\n    &__intro {\n        margin: 9px 0 0;\n        font-size: 14px;\n        line-height: 1.65;\n        color: rgba(21, 36, 30, 0.6);\n        max-width: 620px;\n    }\n\n    &__count {\n        flex: 0 0 auto;\n        display: inline-flex;\n        align-items: center;\n        min-height: 30px;\n        padding: 0 10px;\n        border: 1px solid rgba(130, 177, 148, 0.26);\n        border-radius: 999px;\n        background: rgba(130, 177, 148, 0.09);\n        color: #5E806C;\n        font-size: 11px;\n        font-weight: 800;\n        white-space: nowrap;\n    }\n\n    &__order-note {\n        margin-bottom: 18px;\n        padding: 14px 16px;\n        border: 1px solid rgba(130, 177, 148, 0.22);\n        border-radius: 16px;\n        background: rgba(130, 177, 148, 0.07);\n        color: #53645c;\n        font-size: 13px;\n        line-height: 1.55;\n\n        strong { color: #31473b; }\n    }\n\n    &__header {\n        margin-top: 6px;\n        margin-bottom: 24px;\n        display: flex;\n        justify-content: flex-end;\n\n        @media (max-width: 600px) {\n            margin-top: 10px;\n            margin-bottom: 20px;\n            justify-content: center;\n\n            button {\n                width: 100%;\n                min-height: 44px;\n                border-radius: 14px;\n            }\n        }\n    }\n\n    &__grid {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 14px;\n    }\n\n    &__error-msg {\n        color: #C95C5C;\n        font-size: 13px;\n        font-weight: 700;\n        margin-bottom: 16px;\n        text-align: center;\n    }\n}\n\n// ─── Compact study editor card (saved studies) ───────────────────────────────\n.study-editor-card {\n    position: relative;\n    padding: 18px;\n    border: 1px solid rgba(19, 35, 29, 0.09);\n    border-radius: 20px;\n    background: rgba(255, 255, 255, 0.45);\n    transition: border-color 0.2s ease;\n\n    &:hover {\n        border-color: rgba(130, 177, 148, 0.32);\n    }\n\n    &__head {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 10px;\n        margin-bottom: 12px;\n    }\n\n    &__number {\n        font-size: 12px;\n        font-weight: 800;\n        color: #5f6e68;\n        margin-right: auto;\n    }\n\n    &__actions {\n        display: flex;\n        align-items: center;\n        gap: 7px;\n    }\n\n    &__icon-btn {\n        display: grid;\n        place-items: center;\n        width: 32px;\n        height: 32px;\n        border: 1px solid rgba(19, 35, 29, 0.09);\n        border-radius: 10px;\n        background: #fff;\n        color: #65736d;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover:not(:disabled) {\n            border-color: rgba(130, 177, 148, 0.48);\n            color: #5E806C;\n        }\n\n        &:disabled {\n            opacity: 0.32;\n            cursor: not-allowed;\n        }\n\n        &--delete {\n            color: #C95C5C;\n            background: #FEF2F2;\n            border: 1px solid rgba(201, 92, 92, 0.4);\n\n            &:hover:not(:disabled) {\n                background: #C95C5C;\n                color: #fff;\n                border-color: transparent;\n            }\n        }\n\n        &--edit {\n            color: #5E806C;\n            background: rgba(130, 177, 148, 0.10);\n            border-color: rgba(130, 177, 148, 0.32);\n\n            &:hover:not(:disabled) {\n                background: rgba(130, 177, 148, 0.22);\n                border-color: rgba(130, 177, 148, 0.55);\n                color: #315042;\n            }\n        }\n    }\n\n    &__body {\n        display: flex;\n        flex-direction: column;\n        gap: 0;\n    }\n\n    &__title {\n        display: block;\n        font-size: 15px;\n        font-weight: 700;\n        line-height: 1.4;\n        color: #13231D;\n    }\n\n    &__institution {\n        display: block;\n        margin-top: 4px;\n        font-size: 12px;\n        line-height: 1.5;\n        color: rgba(21, 36, 30, 0.55);\n    }\n\n    &__tags {\n        display: flex;\n        gap: 7px;\n        flex-wrap: wrap;\n        margin-top: 12px;\n    }\n\n    &__tag {\n        display: inline-flex;\n        align-items: center;\n        min-height: 26px;\n        padding: 0 9px;\n        border-radius: 999px;\n        border: 1px solid rgba(130, 177, 148, 0.24);\n        background: rgba(130, 177, 148, 0.08);\n        font-size: 10px;\n        font-weight: 800;\n        color: #496552;\n    }\n\n    &__meta {\n        margin-top: 12px;\n        padding-top: 12px;\n        border-top: 1px dashed rgba(19, 35, 29, 0.09);\n        color: #7b8882;\n        font-size: 10px;\n        line-height: 1.55;\n    }\n\n    &__cert-link {\n        background: none;\n        border: none;\n        color: $bw-primary;\n        font-size: 10px;\n        font-weight: 700;\n        cursor: pointer;\n        padding: 0;\n        font-family: inherit;\n        text-decoration: underline;\n    }\n}\n\n.edit-card {\n    position: relative;\n    background: #ffffff;\n    border: 1px solid $bw-border;\n    border-radius: 20px;\n    padding: 28px;\n    transition: all 0.2s ease;\n\n    @media (max-width: 768px) {\n        padding: 22px;\n    }\n\n    @media (max-width: 480px) {\n        padding: 16px;\n    }\n\n    &:hover {\n        border-color: rgba($bw-primary, 0.3);\n        box-shadow: 0 8px 24px rgba(0,0,0,0.04);\n    }\n\n    &__actions-wrap {\n        position: absolute;\n        top: 16px;\n        right: 16px;\n        display: flex;\n        gap: 8px;\n    }\n\n    &__delete-btn {\n        width: 32px;\n        height: 32px;\n        border-radius: 10px;\n        border: 1px solid rgba(201, 92, 92, 0.4);\n        background: #FEF2F2;\n        color: #C95C5C;\n        display: grid;\n        place-items: center;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover { background: #C95C5C; color: #fff; border-color: transparent; }\n    }\n\n    &__collapse-btn {\n        width: 32px;\n        height: 32px;\n        border-radius: 10px;\n        border: 1px solid rgba(19, 35, 29, 0.10);\n        background: rgba(255, 255, 255, 0.80);\n        color: #6B8277;\n        display: grid;\n        place-items: center;\n        cursor: pointer;\n        font-size: 13px;\n        transition: all 0.2s;\n\n        &:hover { background: rgba(19, 35, 29, 0.06); color: #13231D; }\n    }\n\n\n    &__reorder-btn {\n        width: 32px;\n        height: 32px;\n        border-radius: 10px;\n        border: 1px solid rgba(130, 177, 148, 0.42);\n        background: rgba(255, 255, 255, 0.88);\n        color: #426652;\n        display: grid;\n        place-items: center;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover:not(:disabled) {\n            background: rgba(130, 177, 148, 0.12);\n            color: #13231d;\n            border-color: #82B194;\n        }\n\n        &:disabled {\n            opacity: 0.35;\n            cursor: not-allowed;\n            border-color: rgba(19, 35, 29, 0.08);\n            color: #b0b7b3;\n            background: transparent;\n        }\n    }\n\n    &__form-grid {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 16px;\n        margin-top: 15px;\n    }\n\n    &__row {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 16px;\n        @media (max-width: 600px) { grid-template-columns: 1fr; }\n    }\n\n    &__file-section {\n        margin-top: 8px;\n        padding-top: 16px;\n        border-top: 1px dashed $bw-border;\n    }\n\n    &__label-small {\n        display: block;\n        font-size: 12px;\n        font-weight: 800;\n        text-transform: uppercase;\n        letter-spacing: 0.05em;\n        color: #6B8277;\n        margin-bottom: 10px;\n    }\n\n    &__file-controls {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n\n        @media (max-width: 600px) {\n            flex-direction: column;\n            align-items: stretch;\n            gap: 12px;\n            \n            button { width: 100%; }\n        }\n    }\n\n    &__view-link {\n        background: none;\n        border: none;\n        color: $bw-primary;\n        font-size: 13px;\n        font-weight: 800;\n        text-decoration: underline;\n        cursor: pointer;\n        font-family: inherit;\n    }\n\n    &__loading { padding: 10px; display: flex; justify-content: center; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"studies-tab": `ProfessionalStudiesTab_studies-tab__zyZAU`,
	"studies-tab__empty": `ProfessionalStudiesTab_studies-tab__empty__viNgo`,
	"msp-notice": `ProfessionalStudiesTab_msp-notice__1DM4h`,
	"msp-notice__card": `ProfessionalStudiesTab_msp-notice__card__FQRrY`,
	"msp-notice__icon": `ProfessionalStudiesTab_msp-notice__icon__iYEd8`,
	"msp-notice__text": `ProfessionalStudiesTab_msp-notice__text__Pb0Wn`,
	"studies-editor__header": `ProfessionalStudiesTab_studies-editor__header__EJjaq`,
	"studies-editor__grid": `ProfessionalStudiesTab_studies-editor__grid__2YsTM`,
	"studies-editor__error-msg": `ProfessionalStudiesTab_studies-editor__error-msg__fFKAs`,
	"studies-tab__list": `ProfessionalStudiesTab_studies-tab__list__C-Tcb`,
	"studies-editor__heading": `ProfessionalStudiesTab_studies-editor__heading__gDbsx`,
	"studies-editor__title": `ProfessionalStudiesTab_studies-editor__title__7TpB8`,
	"studies-editor__intro": `ProfessionalStudiesTab_studies-editor__intro__3DRdP`,
	"studies-editor__count": `ProfessionalStudiesTab_studies-editor__count__TG7K6`,
	"studies-editor__order-note": `ProfessionalStudiesTab_studies-editor__order-note__BWtxe`,
	"study-editor-card": `ProfessionalStudiesTab_study-editor-card__wZf-f`,
	"study-editor-card__head": `ProfessionalStudiesTab_study-editor-card__head__prH7g`,
	"study-editor-card__number": `ProfessionalStudiesTab_study-editor-card__number__8lO8+`,
	"study-editor-card__actions": `ProfessionalStudiesTab_study-editor-card__actions__R4LxK`,
	"study-editor-card__icon-btn": `ProfessionalStudiesTab_study-editor-card__icon-btn__WbCEl`,
	"study-editor-card__icon-btn--delete": `ProfessionalStudiesTab_study-editor-card__icon-btn--delete__Ss84S`,
	"study-editor-card__icon-btn--edit": `ProfessionalStudiesTab_study-editor-card__icon-btn--edit__Y3VK9`,
	"study-editor-card__body": `ProfessionalStudiesTab_study-editor-card__body__qJFEU`,
	"study-editor-card__title": `ProfessionalStudiesTab_study-editor-card__title__l+rYi`,
	"study-editor-card__institution": `ProfessionalStudiesTab_study-editor-card__institution__Kx1rA`,
	"study-editor-card__tags": `ProfessionalStudiesTab_study-editor-card__tags__Gd1YU`,
	"study-editor-card__tag": `ProfessionalStudiesTab_study-editor-card__tag__xmqPS`,
	"study-editor-card__meta": `ProfessionalStudiesTab_study-editor-card__meta__JIGh8`,
	"study-editor-card__cert-link": `ProfessionalStudiesTab_study-editor-card__cert-link__5OT0h`,
	"edit-card": `ProfessionalStudiesTab_edit-card__sHcsH`,
	"edit-card__actions-wrap": `ProfessionalStudiesTab_edit-card__actions-wrap__m1tdn`,
	"edit-card__delete-btn": `ProfessionalStudiesTab_edit-card__delete-btn__daTqF`,
	"edit-card__collapse-btn": `ProfessionalStudiesTab_edit-card__collapse-btn__Ext93`,
	"edit-card__reorder-btn": `ProfessionalStudiesTab_edit-card__reorder-btn__Fqlnv`,
	"edit-card__form-grid": `ProfessionalStudiesTab_edit-card__form-grid__VzFgX`,
	"edit-card__row": `ProfessionalStudiesTab_edit-card__row__dW2Au`,
	"edit-card__file-section": `ProfessionalStudiesTab_edit-card__file-section__WLcwR`,
	"edit-card__label-small": `ProfessionalStudiesTab_edit-card__label-small__lkpf5`,
	"edit-card__file-controls": `ProfessionalStudiesTab_edit-card__file-controls__T6Z8o`,
	"edit-card__view-link": `ProfessionalStudiesTab_edit-card__view-link__5KJoK`,
	"edit-card__loading": `ProfessionalStudiesTab_edit-card__loading__DC9gh`
};
export default ___CSS_LOADER_EXPORT___;
